<div class="form-bg-wrapper py-5 px-3 px-md-4 mb-5 mb-md-none">
    <div class="form-container mx-auto bg-white rounded-4 border p-4 p-md-5 shadow-sm">

        <header class="mb-4">
            <h1 class="h4 fw-bold text-dark-navy mb-1 font-inter-bold">Company Details</h1>
            <p class="text-secondary small mb-0">Fill in the details below to verify the company identity</p>
        </header>

        <form [formGroup]="canonForm" (ngSubmit)="onSubmit()" novalidate>
            <div class="row g-4">

                <!-- Easy Number -->
                <div class="col-md-6">
                    <label class="form-label small fw-semibold text-dark">
                        Easy Number
                        @if (isFieldRequired('easyNumber')) {
                        <span class="text-danger">*</span>
                        }
                    </label>
                    <input type="text" class="form-control" formControlName="easyNumber" id="easyNumber"
                        placeholder="Enter easy number"
                        [ngClass]="{'invalid-field': canonForm.get('easyNumber')?.touched && canonForm.get('easyNumber')?.invalid}">
                </div>

                <!-- Company Name -->
                <div class="col-md-6">
                    <label class="form-label small fw-semibold text-dark">
                        Company Name
                        @if (isFieldRequired('companyName')) {
                        <span class="text-danger">*</span>
                        }
                    </label>
                    <input type="text" class="form-control" formControlName="companyName" id="companyName"
                        placeholder="Enter company name"
                        [ngClass]="{'invalid-field': canonForm.get('companyName')?.touched && canonForm.get('companyName')?.invalid}">
                </div>

                <!-- Country -->
                <div class="col-md-6">
                    <label class="form-label small fw-semibold text-dark">
                        Country
                        @if (isFieldRequired('country')) {
                        <span class="text-danger">*</span>
                        }
                    </label>
                    <select class="form-select text-muted" formControlName="country" id="country"
                        [ngClass]="{'invalid-field': canonForm.get('country')?.touched && canonForm.get('country')?.invalid}">
                        <option value="" disabled selected hidden>Select country</option>
                        <option *ngFor="let country of countries" [value]="country.name">{{ country.name }}</option>
                    </select>
                </div>

                <!-- Type -->
                <div class="col-md-6">
                    <label class="form-label small fw-semibold text-dark">
                        Type
                        @if (isFieldRequired('type')) {
                        <span class="text-danger">*</span>
                        }
                    </label>
                    <input type="text" class="form-control" formControlName="type" id="type" placeholder="Enter type"
                        [ngClass]="{'invalid-field': canonForm.get('type')?.touched && canonForm.get('type')?.invalid}">
                </div>

                <!-- Registered Address -->
                <div class="col-12">
                    <label class="form-label small fw-semibold text-dark">
                        Registered Address
                        @if (isFieldRequired('registeredAddress')) {
                        <span class="text-danger">*</span>
                        }
                    </label>
                    <input type="text" class="form-control" formControlName="registeredAddress" id="registeredAddress"
                        placeholder="Enter registered address"
                        [ngClass]="{'invalid-field': canonForm.get('registeredAddress')?.touched && canonForm.get('registeredAddress')?.invalid}">
                </div>

                 <div class="col-md-6">
                    <label class="form-label small fw-semibold text-dark">
                        Credit Recommendation
                        @if (isFieldRequired('companyCreditRecommendation')) {
                        <span class="text-danger">*</span>
                        }
                    </label>
                    <input type="text" class="form-control" formControlName="companyCreditRecommendation" id="companyCreditRecommendation" placeholder="Enter credit recommendation"
                        [ngClass]="{'invalid-field': canonForm.get('companyCreditRecommendation')?.touched && canonForm.get('companyCreditRecommendation')?.invalid}">
                </div>

                  <div class="col-md-6">
                    <label class="form-label small fw-semibold text-dark">
                       Risk Rating 
                        @if (isFieldRequired('companyRiskRating')) {
                        <span class="text-danger">*</span>
                        }
                    </label>
                    <input type="text" class="form-control" formControlName="companyRiskRating" id="companyRiskRating" placeholder="Enter credit recommendation"
                        [ngClass]="{'invalid-field': canonForm.get('companyRiskRating')?.touched && canonForm.get('companyRiskRating')?.invalid}">
                </div>

                <!-- Form Action Buttons -->
                <div class="col-12 d-flex justify-content-end gap-3 mt-4 align-items-center">
                    <button type="button"
                        class="btn btn-link text-secondary text-decoration-none fw-semibold small px-3 py-2"
                        (click)="onCancel()">
                        Cancel
                    </button>
                    <button type="submit"
                        class="btn btn-submit-navy px-4 py-2.5 text-white fw-semibold small rounded-3">
                        Submit Form
                    </button>
                </div>

            </div>
        </form>

    </div>
</div>